<div class="content-grid">
  <div class="column">
    @for (item of leftColumn; track item.title) {
      <div class="item">
        <div class="item-title">{{ item.title }}</div>
        <p [innerHTML]="formatText(item.text) | textClean"></p>
      </div>
    }
  </div>
  <div class="divider"></div>
  <div class="column">
    @for (item of rightColumn; track item.title) {
      <div class="item">
        <div class="item-title">{{ item.title }}</div>
        <p [innerHTML]="formatText(item.text) | textClean"></p>
      </div>
    }
  </div>
</div>
